export default __webpack_public_path__ + "static/media/forge.4cd4282e.svg";